var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import Documents from './documents';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment Documents on Property {\n    listing {\n      documents {\n        downloadUrl\n        label\n      }\n    }\n  }\n"])));
var graphQLToProps = function graphQLToProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$listing = _ref.listing,
    listing = _ref$listing === void 0 ? {} : _ref$listing;
  return {
    documents: listing.documents
  };
};
var DocumentsGraphQL = _ref2 => {
  var property = _ref2.property;
  return ___EmotionJSX(Documents, graphQLToProps(property));
};
DocumentsGraphQL.fragment = fragment;
DocumentsGraphQL.propTypes = {
  property: PropTypes.shape({
    listing: PropTypes.shape({
      documents: PropTypes.arrayOf(PropTypes.shape({
        downloadUrl: PropTypes.string,
        label: PropTypes.string
      }))
    })
  })
};
DocumentsGraphQL.defaultProps = {
  property: {}
};
export default DocumentsGraphQL;